import React from 'react'

import { CHANGE_PAYMENT_METHOD } from '../../../../stores/CartStateStore';
import { ORDER_MAX_CHANGE_THRESHOLD } from '../../../../utils/config';

export default class CashForm extends React.Component {

    handleChange = (event) => {
        let value = event.target.value;
        value = value.replace(',', '.'); // Replace the commas with dots to support the decimal numbers
        value = value.replace(/[^0-9\.]+/g, ''); // Replace non digits

        if (isNaN(parseFloat(value))) {
            value = '';
        }

        this.props.setCashAmount(value)

        this.props.dispatchCartState({type: CHANGE_PAYMENT_METHOD, payload: {type: 'cash', options: {cash_amount: value}}})
    };

    render() {
        const { enabled, errors, requiresCashValue} = this.props;

        if (!enabled) {
            return (
                <div>{I18n.t('cart_summary.venue_no_cash')}</div>
            )
        }

        return (
            <div className="form-group">
                <p className="checkout-info">{I18n.t('cart_summary.payment_in_cash_at_delivery')}</p>

                {requiresCashValue && <div>
                    <label className="control-label">{I18n.t('cash')} *</label>
                    <div className="input-group">
                        <span className="input-group-addon">€</span>
                        <input type="text"
                               className="form-control"
                               name="cash_amount"
                               value={this.props.cartState.paymentMethod.options?.cashAmount}
                               onChange={this.handleChange}/>
                    </div>
                </div>}

                {errors.payment_details && errors.payment_details.map(function (error) {
                    return <div className="help-block error">{error}</div>
                })}

                {this.props.showAlertMessage && <div className="help-block info">{I18n.t('cart_summary.cash_money_at_delivery', {value: ORDER_MAX_CHANGE_THRESHOLD})}</div>}

            </div>
        );
    }
}
